import { Navigate, useLocation } from "react-router-dom";
import { useAgreementConsent } from "../hooks/useAgreementConsent";

export default function RequireConsent({ children }: { children: React.ReactElement }) {
  const { isAgreed } = useAgreementConsent();
  const location = useLocation();
  if (!isAgreed) return <Navigate to="/agreement" replace state={{ from: location }} />;
  return children;
}